export namespace GalleryCarousel {
	let setupSlider = () => {

		let galleryCarousels = document.querySelectorAll('.js-gallery-carousel');

		galleryCarousels.forEach((carousel) => {

			let pauseButton = carousel.querySelector('.js-pause');
			let playButton = carousel.querySelector('.js-play');
			let images:HTMLDivElement = carousel.querySelector('.js-gallery-images');

			// set our animation duration based on the number of images
			let imageCount:number = parseInt(images.getAttribute('data-count'));
			let imageDuration = imageCount * 10;

			// Set the CSS variable value for our animation
			images.style.setProperty('--animation-duration', `${imageDuration}s`);

			// toggle the autoplay play/pause buttons
			let toggleClasses = () => {
				pauseButton.classList.toggle('hide');
				playButton.classList.toggle('hide');
			}

			pauseButton.addEventListener('click', () => {
				toggleClasses();
				images.style.animationPlayState = 'paused';
			});

			playButton.addEventListener('click', () => {
				toggleClasses();
				images.style.animationPlayState = 'running';
			});
		});
	}

	export const init = () => {
		setupSlider();
	}
}

document.addEventListener('DOMContentLoaded', GalleryCarousel.init);
